export default "__VITE_ASSET__yF5gEo_i__"